import { IDashboardComponent } from "../../../types";
import { ReactElement } from "react";

interface IProps {
  component: IDashboardComponent<any>;
}

const TextComponent = ({ component }: IProps): ReactElement | null => {

  return (
    <div className={"display-grid align-items-center h-100"}>
      <strong style={{ textAlign: "center", fontSize: "2em" }}>
        {component.title}
      </strong>
    </div>
  );
};

export default TextComponent;
